import styled from 'styled-components';

const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgb(228, 236, 240);
  overflow: ${props => props.showMobileSidebar && 'hidden'};
`;

const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 1800px;
  background-color: ${props => props.theme.carvana.lightBlue};
  margin: 0 auto;
  min-height: 100vh;
  height: ${props => (props.showMobileSidebar ? '100vh' : '100%')};

  overflow: ${props => props.showMobileSidebar && 'hidden'};
  transform: ${props => props.showMobileSidebar && 'translate3d(80%, 0, 0);'};
  transition: transform 0.3s;

  box-shadow: 1px 2px 3px 1px rgba(24, 53, 88, 0.1);
`;

const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const SidebarLoading = styled.div`
  background-color: #36434c;
  color: #fff;
  position: absolute;
  width: 80%;
  height: 100%;
`;

export { PageWrapper, ContainerWrapper, MainWrapper, SidebarLoading };
